import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5808c5a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<a class=\"asHeaderMobile_back\" data-v-5808c5a8><svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-5808c5a8><g clip-path=\"url(#clip0_3978_3062)\" data-v-5808c5a8><path d=\"M10.828 12.0007L15.071 16.2437C15.4615 16.6342 15.4615 17.2673 15.071 17.6577C14.6805 18.0482 14.0475 18.0482 13.657 17.6577L8.70711 12.7078C8.31658 12.3173 8.31658 11.6841 8.70711 11.2936L13.657 6.34372C14.0475 5.95325 14.6805 5.95325 15.071 6.34372C15.4615 6.73418 15.4615 7.36725 15.071 7.75772L10.828 12.0007Z\" fill=\"#B4B8BB\" data-v-5808c5a8></path></g><defs data-v-5808c5a8><clipPath id=\"clip0_3978_3062\" data-v-5808c5a8><rect width=\"24\" height=\"24\" fill=\"white\" data-v-5808c5a8></rect></clipPath></defs></svg></a>", 1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "asHeaderMobile_col -name" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "asHeaderMobile_col -title" }
const _hoisted_6 = { class: "asHeaderMobile_title" }
const _hoisted_7 = { class: "asHeaderMobile_col -nav" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-5808c5a8><g clip-path=\"url(#clip0_3976_44)\" data-v-5808c5a8><path d=\"M3 5C3 4.44772 3.44772 4 4 4H20C20.5523 4 21 4.44772 21 5C21 5.55228 20.5523 6 20 6H4C3.44772 6 3 5.55228 3 5ZM3 12C3 11.4477 3.44772 11 4 11H14C14.5523 11 15 11.4477 15 12C15 12.5523 14.5523 13 14 13H4C3.44772 13 3 12.5523 3 12ZM3 19C3 18.4477 3.44772 18 4 18H20C20.5523 18 21 18.4477 21 19C21 19.5523 20.5523 20 20 20H4C3.44772 20 3 19.5523 3 19Z\" fill=\"#0E2242\" data-v-5808c5a8></path></g><defs data-v-5808c5a8><clipPath id=\"clip0_3976_44\" data-v-5808c5a8><rect width=\"24\" height=\"24\" fill=\"white\" data-v-5808c5a8></rect></clipPath></defs></svg>", 1)
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ac_points_label = _resolveComponent("ac-points-label")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_as_menu = _resolveComponent("as-menu")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'menuContainer': _ctx.showMenu })
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["asHeaderMobile", {
        '-withoutPoints': !_ctx.showPoints
      }]),
      "data-cy": "asHeaderChat"
    }, [
      (_ctx.showBack)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "asHeaderMobile_col -back",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
          }, _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.avatar)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "asHeaderMobile_avatar",
              src: _ctx.avatar,
              alt: _ctx.title
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.title), 1),
          (_ctx.showPoints)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                class: "asHeaderMobile_points",
                to: { name: 'points' }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ac_points_label, {
                    class: "-enabled",
                    points: _ctx.userScoreAmount
                  }, null, 8, ["points"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _renderSlot(_ctx.$slots, "menu", {}, () => [
        _createElementVNode("div", _hoisted_7, [
          (_ctx.nav)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args))),
                class: "asHeaderMobile_menu"
              }, _hoisted_9))
            : _createCommentVNode("", true)
        ])
      ], true)
    ], 2),
    (_ctx.showMenu)
      ? (_openBlock(), _createBlock(_component_as_menu, {
          key: 0,
          menu: _ctx.menu,
          class: "lSetting_asMenu -setting",
          "onClick:item": _ctx.selectMenuItem
        }, null, 8, ["menu", "onClick:item"]))
      : _createCommentVNode("", true)
  ], 2))
}